// extracted by mini-css-extract-plugin
export var button = "Quantity-module--button--AdOm5";
export var inputField = "Quantity-module--input-field--cvE5a";
export var leftButton = "Quantity-module--left-button--145yz";
export var mainWrapper = "Quantity-module--mainWrapper--tTfwF";
export var rightButton = "Quantity-module--right-button--jNgSe";